import { render, staticRenderFns } from "./BandejaComponente.vue?vue&type=template&id=faa220d2&scoped=true"
import script from "./BandejaComponente.vue?vue&type=script&lang=js"
export * from "./BandejaComponente.vue?vue&type=script&lang=js"
import style0 from "./BandejaComponente.vue?vue&type=style&index=0&id=faa220d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa220d2",
  null
  
)

export default component.exports